import { types } from '../types'

const initialState = {
  LoginWaiting: false,
  loginSuccess: false,
  LoginError: '',
}

const userReducer = (state = initialState, { type, action, error }) => {
  switch (type) {
    case types.LOGIN_REQUEST: {
      return {
        ...state,
        LoginWaiting: true,
        loginSuccess: false,


      }
    }
    case types.LOGIN_REQUEST_SUCCESS: {

      return {
        ...state,
        LoginWaiting: false,
        loginSuccess: true,
        loginData: action.data
      }
    }
    case types.LOGIN_REQUEST_ERROR: {
      return {
        ...state,
        LoginWaiting: false,
        LoginError: action?.error
      }
    }




    case types.USER_RESET_PROPS: {
      return {
        ...state,
        LoginWaiting: false,
        loginSuccess: false,
        LoginError: '',
        user: localStorage.getItem("sipOnlineUser") ? state.user : {}

      }
    }

    default:
      return state
  }
}

export default userReducer
